import { useCallback, useSyncExternalStore } from 'react';

const QUERY = '(max-width: 768px)';

export function useMediaQuery() {
  const subscribe = useCallback((callback: () => void) => {
    const mediaQuery = window.matchMedia(QUERY);
    mediaQuery.addEventListener('change', callback);
    return () => mediaQuery.removeEventListener('change', callback);
  }, []);

  const getSnapshot = useCallback(() => {
    return window.matchMedia(QUERY).matches;
  }, []);

  const getServerSnapshot = useCallback(() => false, []);

  const isOpen = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );

  return { isOpen };
}
